<div class="widget" [ngClass]="{ 'collapsed': collapsed }">
    <ng-container [ngTemplateOutlet]="title === 'Company Name' ? company: title === 'Location' ? location :  title === 'Person Name' ? personName :  commonList">
      <ng-template #company>
        <mat-expansion-panel hideToggle class="mat-expansion-panel" >
            <mat-expansion-panel-header class="mat-expansion-panel-header">
                <mat-panel-description>
                    <div class="widget-name"><button (click)="toggled.emit()">{{ title }}</button></div>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-form-field >
                <mat-chip-grid #chipList2>
                  <mat-chip-option *ngFor="let chip of chips" [selectable]="selectable"
                           [removable]="removable" (removed)="remove(chip)">
                    {{ displayCaption(chip.caption) }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-option>
                  <input
                    matInput placeholder="Enter company name..."
                    [matAutocomplete]="auto"
                    [formControl]="companySearchControl"
                    [matChipInputFor]="chipList2"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur"
                    >
                </mat-chip-grid>
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="selectCompany( $event.option.value )">
                <mat-option *ngIf="isLoading" class="is-loading"></mat-option>
                <ng-container *ngIf="!isLoading">
                    <mat-option
                      *ngFor="let item of suggestionResponse"
                      [value]="item.name"
                    >
                      {{ item.name }} [{{item.count}}]
                    </mat-option>
                </ng-container>
              </mat-autocomplete>
            </mat-form-field>
        </mat-expansion-panel>
        </ng-template>
      <ng-template #personName>
        <mat-expansion-panel hideToggle class="mat-expansion-panel">
          <mat-expansion-panel-header class="mat-expansion-panel-header">
            <mat-panel-description>
              <div class="widget-name"><button (click)="toggled.emit()">{{ title }}</button></div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-form-field >
            <mat-chip-grid #chipList3>
              <mat-chip-option *ngFor="let chip of chips" [selectable]="selectable"
                        [removable]="removable" (removed)="remove(chip)">
                {{ displayCaption(chip.caption) }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-option>
              <input
                matInput placeholder="Enter person name..."
                [matAutocomplete]="auto"
                [formControl]="personSearchControl"
                [matChipInputFor]="chipList3"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
              >
            </mat-chip-grid>
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="selectPerson( $event.option.value )">
              <mat-option *ngIf="isLoading" class="is-loading"></mat-option>
              <ng-container *ngIf="!isLoading">
                <mat-option
                  *ngFor="let item of suggestionResponse"
                  [value]="item.name"
                >
                  {{ item.name }} [{{item.count}}]
                </mat-option>
              </ng-container>
            </mat-autocomplete>
          </mat-form-field>
        </mat-expansion-panel>
      </ng-template>

      <ng-template #location>
        <mat-expansion-panel hideToggle class="mat-expansion-panel">
          <mat-expansion-panel-header class="mat-expansion-panel-header">
            <mat-panel-description>
              <div class="widget-name"><button (click)="toggled.emit()">{{ title }}</button></div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-form-field >
            <mat-chip-grid #chipList3>
              <mat-chip-option *ngFor="let chip of chips" [selectable]="selectable"
                        [removable]="removable" (removed)="remove(chip)">
                {{ displayCaption(chip.caption) }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-option>
              <input
                matInput placeholder="Enter location..."
                [matAutocomplete]="auto"
                [formControl]="locationSearchControl"
                [matChipInputFor]="chipList3"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
              >
            </mat-chip-grid>
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="selectLocation( $event.option.value )">
              <mat-option *ngIf="isLoading" class="is-loading"></mat-option>
              <ng-container *ngIf="!isLoading">
                <mat-option
                  *ngFor="let item of suggestionResponse"
                  [value]="item.name"
                >
                  {{ displayCaption(item.name) }} [{{item.count}}]
                </mat-option>
              </ng-container>
            </mat-autocomplete>
          </mat-form-field>
        </mat-expansion-panel>
      </ng-template>
      <ng-template #commonList>
        <mat-expansion-panel hideToggle  class="mat-expansion-panel"  [expanded]="!collapsed" #mep="matExpansionPanel">
          <mat-expansion-panel-header (click)="toggledChange()" class="mat-expansion-panel-header">
            <mat-panel-description>
              <div class="widget-name"><button>{{ title }}</button></div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-form-field>
            <mat-chip-grid #chipList>
              <mat-chip-option *ngFor="let chip of chips"  [selectable]="selectable"
                        [removable]="removable" (removed)="remove(chip)">
                {{ displayCaption(chip.caption) }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-option>

              <input
                matInput
                placeholder="Enter {{ title }}..."
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                [formControl]="myControl"
              >
            </mat-chip-grid>
            <mat-autocomplete  #auto="matAutocomplete">
              <mat-option *ngFor="let option of filteredOptions | async" [value]="option.caption" (click)="selectItem(option)" >
                {{ displayCaption(option.caption) }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div class="widget-content" >
            <div class="widget-scroll">
              <label class="checkbox" *ngFor="let i of innerItems">
                <input type="checkbox"
                       (click)="selectItem(i)"
                       [name]="'filter_checkbox_item_' + i"
                       [(ngModel)]="i.checked"
                       (ngModelChange)="this.changed.emit({ items: this.innerItems})">
                <span>{{ displayCaption(i.caption) }}</span>
              </label>
            </div>
          </div>
        </mat-expansion-panel>
      </ng-template>
    </ng-container>


</div>
